'use client'

import { AppTrans } from '@mntn-dev/app-common'
import { useQueryParams, useRouter } from '@mntn-dev/app-navigation'
import { route, signOutUrl } from '@mntn-dev/app-routing'
import { useTranslation } from '@mntn-dev/i18n'
import { Button } from '@mntn-dev/ui-components/buttons'
import { GradientIcon } from '@mntn-dev/ui-components/gradient-icon'
import { Heading } from '@mntn-dev/ui-components/heading'
import { HorizontalList } from '@mntn-dev/ui-components/horizontal-list'
import { Stack } from '@mntn-dev/ui-components/stack'
import { Tag } from '@mntn-dev/ui-components/tag'
import { Text } from '@mntn-dev/ui-components/text'

export const WelcomePage = () => {
  const { t } = useTranslation(['welcome'])
  const router = useRouter()
  const queryParams = useQueryParams<'/welcome'>()

  const handleBackClick = () => {
    router.pushUrl(signOutUrl(queryParams.returnTo))
  }

  const handleSignUpClick = () => {
    router.push(route('/sign-up').query(queryParams))
  }

  return (
    <Stack
      gap="8"
      direction="col"
      className="my-48 text-center items-center"
      width="144"
    >
      <Stack className="items-center" gap="4" direction="col">
        <GradientIcon
          name="nav-projects"
          size="4xl"
          gradient="green-glass-10"
        />
        <Heading fontSize="4xl" className="-my-2">
          <AppTrans
            t={t}
            i18nKey="welcome:title"
            components={{
              br: <br />,
            }}
          />
        </Heading>
      </Stack>
      <Tag
        icon={{ fill: 'solid', name: 'shield-check' }}
        onDismiss={() => {}}
        textTransform="none"
        type="brand"
      >
        {t('authenticated')}
      </Tag>
      <Stack gap="6" direction="col" className="items-center">
        <Text fontSize="sm" textColor="secondary">
          {t('welcome:subtitle')}
        </Text>
        <HorizontalList
          items={[
            t('welcome:bullet.1'),
            t('welcome:bullet.2'),
            t('welcome:bullet.3'),
          ]}
        />
      </Stack>
      <Stack gap="4" direction="col">
        <Button
          type="button"
          onClick={handleSignUpClick}
          width="full"
          className="px-8"
          iconRight="arrow-right"
        >
          {t('welcome:action.signup')}
        </Button>
        <Button
          type="button"
          onClick={handleBackClick}
          variant="text"
          iconLeft="arrow-left"
          size="sm"
        >
          {t('welcome:action.back')}
        </Button>
      </Stack>
    </Stack>
  )
}
